import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback } from 'preact/compat';
import { useController, useFormContext, } from 'react-hook-form';
import { clsx } from 'clsx';
import FormGroup from '@enquiryForm/components/FormGroup';
import FormLabel from '@enquiryForm/components/FormLabel';
import FormError from '@enquiryForm/components/FormError';
function TextInput(props) {
    const { inputAttrs, labelAttrs, forceError, maybeTextTransform, } = props;
    const { name, className: forwardedInputClasses } = inputAttrs;
    const { control, setValue, formState: { isSubmitted } } = useFormContext();
    const { field: { value }, fieldState: { invalid, isTouched, error }, } = useController({ name, control });
    const className = clsx('form__control', forwardedInputClasses, { invalid: invalid && (isTouched || isSubmitted || forceError) });
    const handleInputChange = useCallback((ev) => {
        let fieldValue = inputAttrs.maxLength && typeof inputAttrs.maxLength === 'number'
            ? ev.currentTarget.value.substring(0, inputAttrs.maxLength)
            : ev.currentTarget.value;
        if (maybeTextTransform) {
            fieldValue = maybeTextTransform(fieldValue);
        }
        setValue(name, fieldValue, { shouldTouch: true, shouldValidate: true });
    }, [inputAttrs, maybeTextTransform, name, setValue]);
    return (_jsxs(FormGroup, { className: error ? 'form__group--error' : '', children: [_jsx(FormLabel, { ...labelAttrs }), _jsx("input", { ...inputAttrs, onChange: handleInputChange, value: value, className: className }), (error && (isTouched || isSubmitted || forceError)) && (_jsx(FormError, { children: error?.message }))] }));
}
TextInput.defaultProps = {
    forceError: false,
    maybeTextTransform: undefined,
};
export default TextInput;
